import { useContext } from 'react'
import ModalContext from '../contexts/ModalProvider'

const useModal = () => {
    return useContext(ModalContext)
}

export default useModal
